export const COMPLETED_IMPORT_SHIFTBAR_NOTICE_MESSAGE =
    "Click here to access your completed import.";

/**
 * @param {{ name?: string|null }} progress
 * @param {string|null|undefined} filename
 */
export function buildImportCompletionLabel(progress, filename) {
    const name = progress?.name ?? "Import Job";

    return filename ? `${name} - ${filename}` : name;
}

/**
 * @param {{ id: number|string, type?: string|null }} progress
 */
export function buildCompletedImportShiftbarNotice(progress) {
    return {
        progressId: progress.id,
        type: progress.type ?? null,
    };
}

/**
 * The shiftbar hint is redundant while the operations menu is already open.
 */
export function shouldClearCompletedImportShiftbarNotice(
    notice,
    isOperationsMenuOpen,
) {
    return Boolean(notice && isOperationsMenuOpen);
}
